/**
 * Canonical user-agreement text — the single source of truth for both the
 * signing modal and the `agreementMessage` persisted with the signature.
 *
 * The signed log entry is the evidentiary record of what the admin accepted, so
 * the text rendered in AgreementModal and the text sent to `signAgreement` must
 * come from here and never diverge. Gen1 kept the same string on its App
 * component and posted it verbatim (mcr/src/components/App/App.ts).
 */

export const AGREEMENT_VERSION = '10.22.24'

export const AGREEMENT_PARAGRAPHS = [
	'The Customer acknowledges that the Customer’s Facility Users will be provided with access to the TurnCare Information System Dashboards, which may include patient-stay identifier codes, patient room numbers, Guardian device serial numbers, device status, usage events, and interpretative summaries from Guardian devices in use at Customer’s facility.',
	'If applicable, for the duration of an Evaluation Period, Customer agrees to allow TurnCare to manage evaluation single-user access to the TurnCare Information System Dashboards. Subscription Customers will be provided with Customer-managed access to the TurnCare Information System Dashboards as permitted by an administrator designated by Customer.',
	'Customer Administrator assumes responsibility for onboarding and off-boarding Customer Users.',
] as const

/** Paragraph breaks are preserved so the Logs details dialog renders the text as the signer saw it. */
export const AGREEMENT_MESSAGE = AGREEMENT_PARAGRAPHS.join('\n\n')
